import * as yup from "yup";
import { validationSchemas } from "./data";
export const orderTypeSchema = yup.object().shape({
  orderTypeName: validationSchemas.name,
  orderTypeAlt: validationSchemas.name,
});
